import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated } from '../services/authService';

/**
 * ProtectedRoute - HOC para proteger rotas que requerem autenticação
 * Redireciona para login se o usuário não estiver autenticado
 */
const ProtectedRoute = ({ children }) => {
  if (!isAuthenticated()) {
    // Usuário não autenticado, redireciona para login
    return <Navigate to="/" replace />;
  }

  // Usuário autenticado, renderiza o componente filho
  return children;
};

export default ProtectedRoute;
